export const getClassroom = (state, { classroomId }) =>
  classroomId ? state.entity.classroomsById[classroomId] : null;
